<template>
  <component :is="type" :icon="icon" class="dea-chip" v-on="$listeners">
    <span class="dea-chip__label">
      <slot />
    </span>
    <div
      v-if="icon"
      class="dea-chip__icon icon"
      :class="[getIcon(icon), `dea-chip__icon--${iconColorModifier}`]"
      :aria-label="icon"
    ></div>
  </component>
</template>

<script>
/**
 * Le chips sono utilizzabili come elementi singoli o multipli. Vengono usate quando il contenuto è mappato in più categorie e l'utente deve trovare un modo per distinguerle. Le chips con bottone di chiusura possono anche essere utilizzate come metodo di filtraggio dei dati, per mostrare solo gli elementi all'interno di una particolare categoria. Le chips sono gestibili tramite i colore di background nei tokens.
 */
export default {
  name: "Chips",

  props: {
    type: {
      type: String,
      default: "button",
    },
    icon: {
      type: String,
      default: "",
    },
    iconColorModifier: {
      type: String,
      default: "",
    },
  },
  methods: {
    getIcon(icon) {
      return `dea-ico-${icon}`;
    },
  },
};
</script>
